import { Page, PageProps } from "@react-pdf/renderer";
import { PropsWithChildren } from "react";
import { pdfLetterSize } from "@app/utils/pdfUtils";
import { CarPdfBox } from "./PdfBox";
import { CarPdfTypography } from "./PdfTypography";
import { useTheme } from "@mui/material";

export interface CarPdfPageProps
  extends PropsWithChildren<Omit<PageProps, "size" | "dpi">> {
  sectionTitle?: string;
  reportTitle?: string;
  footer: string;
}

const defaultPadding = 35;
const defaultPaddingBottom = 58;

export const defaultClientPageSize = {
  width: pdfLetterSize.width - defaultPadding - defaultPadding,
  height: pdfLetterSize.height - defaultPadding - defaultPaddingBottom,
};

export const CarPdfPage = ({
  children,
  style,
  footer,
  sectionTitle,
  reportTitle,
  ...props
}: CarPdfPageProps) => {
  const theme = useTheme();
  return (
    <Page
      size={pdfLetterSize}
      style={{
        paddingTop: defaultPadding,
        paddingLeft: defaultPadding,
        paddingRight: defaultPadding,
        paddingBottom: defaultPaddingBottom,
        ...style,
      }}
      {...props}
    >
      <CarPdfBox
        style={{
          flexDirection: "row",
        }}
      >
        <CarPdfBox
          style={{
            flexDirection: "column",
          }}
        >
          <CarPdfTypography
            variant="v12Bold"
            italic
            dense
            style={{
              paddingTop: 4,
              fontSize: 12,
              lineHeight: 12,
            }}
          >
            {sectionTitle}
          </CarPdfTypography>
          <CarPdfTypography
            variant="v14Bold" // temporary
            style={{
              alignSelf: "flex-start",
              fontWeight: "bold",
              paddingTop: 8,
              paddingBottom: 2,
              paddingRight: 2,
              fontSize: 20,
              lineHeight: 20,
              letterSpacing: -0.4,
              borderBottomWidth: 1,
              borderBottomStyle: "solid",
              borderBottomColor: theme.palette.caravelOrangePrimary,
            }}
          >
            {reportTitle}
          </CarPdfTypography>
        </CarPdfBox>
        <CarPdfTypography
          variant="v11Semibold"
          italic
          style={{
            marginTop: 7,
            marginLeft: "auto",
          }}
        >
          INTERNAL USE ONLY
        </CarPdfTypography>
      </CarPdfBox>
      {children}

      <CarPdfBox
        fixed
        style={{
          position: "absolute",
          bottom: 44,
          left: 35,
          right: 35,
        }}
      >
        <CarPdfTypography
          variant="v11Regular"
          italic
          dense
          style={{ textAlign: "right" }}
        >
          {footer}
        </CarPdfTypography>
      </CarPdfBox>
    </Page>
  );
};
